/* eslint-disable import/prefer-default-export */
import { ConfigHelpers } from 'sdk-ui-web-library-common'
import { oneYearFromNowInSeconds } from './dateHelper'

const optInsVersion = 'v1'

/**
 * Gets an almost complete array of opt-ins to
 * be sent to the EMS service. The missing
 * property is "origin", and is set by the IDM
 * API Client.
 *
 * @param {Object.<string, boolean>} optInsSelection The selection of opt-ins in the form
 * @param {object} config The brand SDK configuration
 * @param {string} brandKey The brand key
 * @param {string|undefined} phoneNumber The phone number of the user
 * @returns {object[]} An array of opt-ins with the "origin" property missing
 */
export function getPartialOptInsForEMS(optInsSelection, config, brandKey, phoneNumber) {
  // In the case where the opt-ins are missing, we just return an empty
  // array.
  const configOptIns = (() => {
    const m = ConfigHelpers.getConfigOptIns(config, true).reduce((acc, curr) => {
      acc[curr.identifier] = curr
      return acc
    }, {})
    if (typeof optInsSelection === 'object') {
      return Reflect.ownKeys(optInsSelection).map((k) => m[k]).filter((v) => v)
    } if (Array.isArray(optInsSelection)) {
      return optInsSelection.map((k) => m[k]).filter((v) => v)
    }
    return []
  })()
  return configOptIns.map((configOptIn) => {
    const { identifier, expirationDate, purpose = '' } = configOptIn
    const status = optInsSelection[identifier] ? 1 : 0
    const expiresIn = expirationDate < 0
      ? oneYearFromNowInSeconds()
      : expirationDate - (Date.now() / 1000)
    const result = {
      id: identifier,
      version: optInsVersion,
      source: window.location.origin,
      expiresIn,
      status,
      brand: brandKey,
      purpose, // it could be missing
    }
    if (phoneNumber && identifier === ConfigHelpers.KnownOptIns.SMS_CONSENT) {
      result.phoneNumber = phoneNumber
    }
    return result
  })
}

/**
 * Extracts the opt-in IDs obtained after the OAuth flow, they
 * come with a special format, something like: a:b:c|d; we
 * know that "b" is always the opt-in ID, we also know that
 * if "d" is true then the opt-in was accepted by the user.
 *
 * @param {string} oauthOptIns The opt-ins given by OAuth
 *
 * @returns {Object.<string,boolean>} The selection of opt-ins
 */
export function extractOptInsGivenByOAuth(oauthOptIns) {
  const selection = {}
  oauthOptIns.split('|').forEach((optInData) => {
    const [nameData, valueData] = optInData.split('=')
    const optInIdentifier = nameData.split(':')[1]
    selection[optInIdentifier] = valueData === 'true'
  })
  return selection
}
